module.exports = __webpack_public_path__ + "static/img/1-1.0063580.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/1/1-1.png
// module id = 2s+z
// module chunks = 0